import { render, staticRenderFns } from "./Candle.vue?vue&type=template&id=f7808912&scoped=true&"
import script from "./Candle.vue?vue&type=script&lang=js&"
export * from "./Candle.vue?vue&type=script&lang=js&"
import style0 from "./Candle.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Candle.vue?vue&type=style&index=1&id=f7808912&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7808912",
  null
  
)

export default component.exports